<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Gestion des sous-catégories de document
            </strong>
          </div>
          <b-card-body>
            <v-client-table :columns="columns" :data="allSousCategories" :options="options" ref="sous_categories_table">
              <div slot="afterFilterWrapper" v-if="canManageCategorie">
                <b-button type="button" @click="editSousCategorie()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer une sous-catégorie
                </b-button>
              </div>
              
              <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
                <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
              </div>
              <div v-if="props.row.categorie_id" slot="categorie_id" slot-scope="props">
                {{ !isEmpty(props.row.categorie) ? props.row.categorie.libelle : '' }}
              </div>
              <div v-if="canManageCategorie" slot="action" slot-scope="props" class="w-auto">
                <i v-b-tooltip.hover title="Modifier la sous-catégorie" class="mr-2 fa fa-edit fa-1_5x text-primary clickable" @click="editSousCategorie(props.row)"></i>
                <i v-b-tooltip.hover title="Supprimer la sous-catégorie" class="fa fa-trash fa-1_5x text-danger clickable" @click="deleteSousCategorie(props.row.id)"></i>
              </div>
            </v-client-table>
            <b-row>
              <b-col sm="12" v-if="canManageCategorie">
                <b-button type="button" @click="editSousCategorie()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer une sous-catégorie
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <modal-sous-categorie :selectedSousCategory="selectedSousCategoryToModify" :categoryOptions="categoryOptions"></modal-sous-categorie>
  </div>
</template>

<script>
import {espaceBibliothequeRules as rules, hasRule} from '@/utils/rulesHelper';
import {isEmpty} from '@/utils/fileHelper';
import {formatDate} from '@/utils/communHelper';
import ModalSousCategorie from './ModalSousCategorie';

export default {
  components: {
    ModalSousCategorie,
  },
  data() {
    return {
      isEmpty,
      formatDate,
      libelle: '',
      libelle_technique: '',
      categorie_id: '',
      modalTitle: 'Création d\'une sous-catégorie de document',
      selectedSousCategoryToModify: null,
      selectedSousCategory: null,
      allSousCategories: [],
      categoryOptions: [],
      allCategories: [],
      columns: [
        'created_at',
        'libelle',
        'libelle_technique',
        'categorie_id',
        'action'
      ],
      options: {
        headings: {
          created_at: 'Date de création',
          libelle: 'Libellé',
          libelle_technique: 'Libellé technique',
          categorie_id: 'Categorie',
          action: ''
        },
        columnsClasses: {
          created_at: "column-xs",
        },
        sortable: ['libelle'],
        filterable: ['libelle'],
        perPage: 10,
        perPageValues: [10, 50, 100],
        texts: {
          filterPlaceholder: 'Libellé'
        },
        orderBy: { column: 'created_at', ascending: false }
      },
      errors: {
        libelle: '',
        libelle_technique: '',
        categorie_id: '',
      }
    }
  },
  created() {
    this.getCategories();
    this.getSousCategories();

    this.$event.on('refresh-sous-categorie-document', () => {
      this.getSousCategories();
      this.selectedSousCategoryToModify = null;
    });
  },
  methods: {
    getSousCategories() {
      this.$store.commit("IS_LOADING", true);
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/sous-categories')
        .then(response => {
          this.allSousCategories = response.data.sousCategories;
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des sous-catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
    getCategories() {
      return new Promise((resolve, reject) => {
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/categories')
        .then(response => {
          this.allCategories = response.data.categories;
          for (let row of response.data.categories) {
            this.categoryOptions.push({text: row.libelle, value: row.id});
          }
          resolve();
        })
        .catch(function(error) {
          console.log(error)
          resolve();
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
      })
    },
    editSousCategorie(sousCategorie) {
      if (!isEmpty(sousCategorie)) {
        this.selectedSousCategoryToModify = sousCategorie;
      }
      this.$bvModal.show('modal-sous-categorie');
    },
    deleteSousCategorie(sousCategorieId) {
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette sous-catégorie ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/sous-categorie/delete/"+sousCategorieId)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'La sous-catégorie a bien été supprimée',showConfirmButton: false, timer: 5000})
              this.getSousCategories()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression de la sous-catégorie, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
    },
    canManageCategorie() {
      return hasRule(rules.CAN_MANAGE_CATEGORIE);
    },
  }
}
</script>

<style>
  .small-action {
    width:  5%;
  }
</style>
